import { Fragment, useCallback } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import OperatorEdit from 'system/components/operators/edit';
import { CommonOperatorCrumbs } from 'system/constants/common-operator-crumbs';
import { useNavigate } from 'react-router-dom';

const OperatorEditPage = (): React.ReactElement => {
  const navigate = useNavigate();

  const onSuccess = useCallback(() => {
    navigate('/sistema/operatori');
  }, [navigate]);

  const onCancel = useCallback(() => {
    navigate('/sistema/operatori');
  }, [navigate]);

  return (
    <Fragment>
      <Breadcrumbs items={[...CommonOperatorCrumbs, { name: 'Modifica Operatore' }]} />
      <OperatorEdit onCancel={onCancel} onSuccess={onSuccess} />
    </Fragment>
  );
};

OperatorEditPage.displayName = 'Operator Edit page component';

export default OperatorEditPage;
